export default __webpack_public_path__ + "static/media/sneakerswipe.e7021d2e.mp4";